import CustomerServiceTree from "./serviceTree/CustomerServiceTree";
import WizardModule from "../wizardmodule/WizardModule";

type Props = {
  disableFp?: boolean;
  fpConfig: any;
  onSetFpService: (customerChoice: string) => void;
  onSaveClick: () => void;
  showSaveButton: boolean;
  onToggleChildServices: (ids: string[], enabled: boolean) => void;
};

export default function CustomerServiceEdit({
  fpConfig,
  onSetFpService,
  onSaveClick,
  showSaveButton,
  onToggleChildServices
}: Props) {
  return (
    <WizardModule
      showSaveButton={showSaveButton}
      onSaveClick={onSaveClick}
      moduleTitle="Digitala tjänster"
      info="Här väljer du vilka mappar som ska finnas i Dokumentarkivet. Rapporter är ej ett val, då den skapas per automatik."
    >
      <CustomerServiceTree
        fpConfig={fpConfig}
        onSetFpService={onSetFpService}
        onToggleChildServices={onToggleChildServices}
      />
    </WizardModule>
  );
}
